import React, { useEffect } from "react";
import { useRoutes, useLocation } from "react-router-dom";
import "react-image-lightbox/style.css";
import ReactGA from "react-ga";
import { useSelector, useDispatch } from "react-redux";

import { ThemeProvider } from "@material-ui/styles";
import { getThemeByBrand, GlobalStyles } from "@packages/ui";

import routes from "./routes";
import SnackBar from "../src/layouts/SnackBar";
import IdleTimerContainer from "../src/layouts/IdleTimerContainer";
import getBrandFromUrl from "./utils/getBrandFromUrl";
import getCountryFromURL from "./utils/getCountryFromUrl";
import * as constants from "./utils/constants";

import { googleAnalyticsURI } from "./env";

ReactGA.initialize(googleAnalyticsURI);

function getFaviconEl() {
  return document.getElementById("favicon");
}


function useContentsquareTracking() {
  const location = useLocation();
  const country = getCountryFromURL();

  const trackingId = country == "AU" ? "0783b7f092cab" : "b92f967352473";

  useEffect(() => {
    const path = location.pathname + location.hash.replace("#", "?__");

    window._uxa = window._uxa || [];

    if (typeof window.CS_CONF === "undefined") {
      window._uxa.push(["setPath", path]);

      const mt = document.createElement("script");
      mt.type = "text/javascript";
      mt.async = true;
      mt.src = `//t.contentsquare.net/uxa/${trackingId}.js`;
      document.head.appendChild(mt);
    } else {
      window._uxa.push(["trackPageview", path]);
    }
  }, [location]);
}


const App = () => {
  const brand = getBrandFromUrl();
  const theme = getThemeByBrand(brand);
  const routing = useRoutes(routes);
  const favicon = getFaviconEl();
  useContentsquareTracking();

  const checkin = useSelector((state) => state.checkin);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    switch (brand) {
      case "Ace":
        favicon.href = constants.ACE_FAVICON_HREF;
        break;
      case "Firefly":
        favicon.href = constants.FIREFLY_FAVICON_HREF;
        break;
      case "Dollar":
        favicon.href = constants.DOLLAR_FAVICON_HREF;
        break;
      case "Thrifty":
        favicon.href = constants.THRIFTY_FAVICON_HREF;
        break;
      default:
        break;
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {routing}
      {checkin.isGenericCheckin && <IdleTimerContainer />}
      {/* <SnackBar /> */}
    </ThemeProvider>
  );
};

export default App;
